"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDependency = exports.installDependency = void 0;
var installDependency = function (url, doc) {
    if (doc === void 0) { doc = document; }
    var element;
    if (url.endsWith('.css')) {
        element = doc.createElement('link');
        element.rel = 'stylesheet';
        element.href = url;
        doc.querySelector('head').appendChild(element);
    }
    else if (url.endsWith('.js')) {
        element = doc.createElement('script');
        element.src = url;
        doc.querySelector('body').appendChild(element);
    }
    return new Promise(function (res) {
        element.onerror = function () { return res(); };
        element.onload = function () { return res(); };
    });
};
exports.installDependency = installDependency;
var removeDependency = function (url, doc) {
    var _a, _b;
    if (doc === void 0) { doc = document; }
    if (url.endsWith('.css')) {
        (_a = doc.querySelector("link[href=\"".concat(url, "\"]"))) === null || _a === void 0 ? void 0 : _a.remove();
    }
    else if (url.endsWith('.js')) {
        (_b = doc.querySelector("script[src=\"".concat(url, "\"]"))) === null || _b === void 0 ? void 0 : _b.remove();
    }
};
exports.removeDependency = removeDependency;
